import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import App from './App.vue'
import router from './router'
import store from './store'

// Register global components (reusable from existing project)
import BaseButton from './components/BaseButton.vue'
import Card from './components/Card.vue'
import BaseHeader from './components/BaseHeader.vue'
import Modal from './components/Modal.vue'
import BaseDropdown from './components/BaseDropdown.vue'
import FilterSidebar from './components/FilterSidebar.vue'
import BaseInput from './components/BaseInput.vue'
import BaseAlert from './components/BaseAlert.vue'
import Notifications from './components/Notifications.vue'

Vue.use(BootstrapVue)
Vue.use(ElementUI)

Vue.component('BaseButton', BaseButton)
Vue.component('Card', Card)
Vue.component('BaseHeader', BaseHeader)
Vue.component('Modal', Modal)
Vue.component('BaseDropdown', BaseDropdown)
Vue.component('FilterSidebar', FilterSidebar)
Vue.component('BaseInput', BaseInput)
Vue.component('BaseAlert', BaseAlert)
Vue.component('Notifications', Notifications)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
console.log('Registered actions:', store._actions)
console.log('Store modules:', store._modules.root._children)
